import { z, ZodType } from 'zod'

import {
  FEEDBACK_ATTACHMENT_ALLOWED_FORMATS,
  FEEDBACK_ATTACHMENT_MAX_FILES,
  FEEDBACK_ATTACHMENT_MAX_FILE_SIZE_MB,
  FEEDBACK_ATTACHMENT_MAX_TOTAL_SIZE_MB,
  hasAllowedFeedbackFileType,
  isWithinFeedbackFileSizeLimit,
  isWithinFeedbackTotalSizeLimit,
  totalFeedbackAttachmentBytes,
} from '@/lib/feedback-attachments'

// Submit-time backstop. Files are already screened as they are added (lib/feedback-attachments),
// so these only fire if a file reaches the form some other way; the rules themselves live there.
export const FeedbackSchema = z
  .object({
    type: z.string().min(1),
    message: z.string().trim().min(1).max(500),
    files: (z.any() as ZodType<File[]>).optional(),
  })
  .refine(({ files }) => !files || files.length <= FEEDBACK_ATTACHMENT_MAX_FILES, {
    params: {
      i18n: { key: 'custom.file.count_too_large', values: { count: FEEDBACK_ATTACHMENT_MAX_FILES } },
    },
    path: ['files'],
  })
  .refine(({ files }) => !files || files.every(hasAllowedFeedbackFileType), {
    params: {
      i18n: {
        key: 'custom.file.not_supported',
        values: { formats: FEEDBACK_ATTACHMENT_ALLOWED_FORMATS.join(', ') },
      },
    },
    path: ['files'],
  })
  .refine(({ files }) => !files || files.every(isWithinFeedbackFileSizeLimit), {
    params: {
      i18n: { key: 'custom.file.too_large', values: { maxSize: `${FEEDBACK_ATTACHMENT_MAX_FILE_SIZE_MB}MB` } },
    },
    path: ['files'],
  })
  .refine(({ files }) => !files || isWithinFeedbackTotalSizeLimit(totalFeedbackAttachmentBytes(files)), {
    params: {
      i18n: {
        key: 'custom.file.total_too_large',
        values: { maxSize: `${FEEDBACK_ATTACHMENT_MAX_TOTAL_SIZE_MB}MB` },
      },
    },
    path: ['files'],
  })
